export default __webpack_public_path__ + "static/media/conservador.5e0b7938.png";